import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row g-5 g-xl-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xl-6" })
], -1)
const _hoisted_2 = { class: "row g-5 g-xl-12" }
const _hoisted_3 = { class: "col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrainerWithCourse = _resolveComponent("TrainerWithCourse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TrainerWithCourse, { "widget-classes": "card-xl-stretch mb-5 mb-xl-8" })
      ])
    ])
  ], 64))
}